import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';

export const setAltchaToken = createAction(
  `${reduxKey}.ALTCHA_SET_TOKEN`,
  (verificationToken: string | undefined) => ({ verificationToken })
);

export const clearAltchaToken = createAction(
  `${reduxKey}.ALTCHA_CLEAR_TOKEN`,
  () => ({})
);
